import { Flex, Grid, Text } from "theme-ui";
import type { JSX } from "react";
import { resp } from "packages/dsaui/src/utils";

interface LayoutProps {
  children: React.ReactNode;
  title: string;
}

interface PageProps {
  children: JSX.Element | JSX.Element[];
}

export const Page = ({ children }: PageProps): JSX.Element => {
  return (
    <Grid
      sx={{
        justifyContent: "center",
        alignItems: "start",
        columnGap: 5,
        rowGap: 4,
        mx: "auto",
        mt: resp("page.mobile", "page.desktop"),
        bg: "white",
        color: "text",
        p: 5,
      }}
    >
      {children}
    </Grid>
  );
};

export const Layout = ({ children, title }: LayoutProps): JSX.Element => (
  <Page>
    <Flex
      sx={{
        bg: "background",
        p: resp(3, 5),
        placeSelf: "center",
        width: "100%",
        maxWidth: "660px",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Text as="h2" variant="heading">
        {title}
      </Text>
      {children}
    </Flex>
  </Page>
);

export default Layout;
